import { render } from "./FeeItem.vue?vue&type=template&id=332a19c6&scoped=true"
import script from "./FeeItem.vue?vue&type=script&lang=js"
export * from "./FeeItem.vue?vue&type=script&lang=js"

import "./FeeItem.vue?vue&type=style&index=0&id=332a19c6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332a19c6"]])

export default __exports__